export enum LogEventType {
  Duty = 1,
  Intermediate = 2,
  PersonalUse = 3,
  Certification = 4,
  Login = 5,
  Engine = 6,
  Diagnostic = 7,
}

export enum DutyEventCode {
  OffDuty = 1,
  SleeperBerth = 2,
  Driving = 3,
  OnDuty = 4,
}

export enum IntermediateEventCode {
  Conventioanl = 1,
  Reduced = 2,
}

export enum PersonalUseEventCode {
  PersonalConveyance = 1,
  YardMove = 2,
}

export enum CertificationEventCode {
  Certification = 1,
}

export enum LoginEventCode {
  Login = 1,
  Logout = 2,
}

export enum EngineEventCode {
  PowerOnConventional = 1,
  PowerOnReduced = 2,
  PowerOffConventional = 3,
  PowerOffReduced = 4,
}

export enum MalfunctionEventCode {
  MalfunctionLogged = 1,
  MalfunctionCleared = 2,
  DiagnosticLogged = 3,
  DiagnosticCleared = 4,
}
